import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  type ExternalLink,
  useDeleteExternalLinkMutation,
  useUpdateExternalLinkMutation,
} from "@src/__generated__/urql-graphql";
import { ModalConfirm } from "@src/components/ui-kit";
import { DataTableActionButton } from "@src/components/ui-kit/DataTable/DataTableActionButton";
import { observer } from "mobx-react-lite";
import { type FC, Fragment, useContext, useRef } from "react";
import { DocumentsCtx } from "../../StoreDocuments";
import { ExtLinkCreateForm, type TExtLinkCreateFormRef } from "./CreateForm";

export const PopoverRowActions: FC<{ link: ExternalLink }> = observer(
  function PopoverRowActions({ link }) {
    const store = useContext(DocumentsCtx);
    const extLinkFormRef = useRef<TExtLinkCreateFormRef>(null);

    const editModal = useDisclosure();
    const deleteModal = useDisclosure();

    const [{ fetching: updating }, updateExtLink] =
      useUpdateExternalLinkMutation();
    const [{ fetching: deleting }, deleteExtLink] =
      useDeleteExternalLinkMutation();

    return (
      <Fragment>
        <Menu>
          <MenuButton
            as={DataTableActionButton}
            isLoading={updating || deleting}
          />
          <MenuList>
            <MenuItem onClick={editModal.onOpen}>
              <Trans>Edit</Trans>
            </MenuItem>
            <MenuItem onClick={deleteModal.onOpen}>
              <Trans>Delete</Trans>
            </MenuItem>
          </MenuList>
        </Menu>
        <ModalConfirm
          heading={t`Delete external link`}
          onClose={deleteModal.onClose}
          isOpen={deleteModal.isOpen}
          isLoading={deleting}
          onConfirm={async () => {
            await deleteExtLink({ id: link.id });
            deleteModal.onClose();
            store.refetchExtLinks?.();
          }}
        >
          <Trans>Do you really want to delete</Trans>&nbsp;
          {link.title}
        </ModalConfirm>
        <ModalConfirm
          heading={t`Edit external link`}
          onConfirm={() => {
            extLinkFormRef.current?.onSubmit();
          }}
          isOpen={editModal.isOpen}
          onClose={editModal.onClose}
          isLoading={updating}
        >
          <ExtLinkCreateForm
            ref={extLinkFormRef}
            type={store.extLinkType}
            initState={link}
            brandOptions={store.brands}
            projectOptions={store.projects}
            onSubmit={(form) => {
              updateExtLink({
                input: {
                  id: link.id,
                  title: form.title,
                  link: form.link,
                  model_id: link.model_id,
                  model_type: link.model_type,
                },
              }).then(() => {
                editModal.onClose();
                store.refetchExtLinks?.();
              });
            }}
          />
        </ModalConfirm>
      </Fragment>
    );
  },
);
